import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, truncateText } from 'elbuild-ui-lib-core';
import { Project, ProjectService, ProjectGantt } from 'toolbandi-ui-lib';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


am4core.useTheme(am4themes_animated);

@Component({
	selector: 'app-project-gantt',
	templateUrl: './project-gantt.component.html',
	styleUrls: ['./project-gantt.component.scss']
})
export class ProjectGanttComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() project: Project;
	gantt: ProjectGantt;
	loading: boolean = false;
	colors: am4core.Color[] = [];
	chart: am4charts.XYChart;

	constructor(private projectService: ProjectService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal) { }

	ngOnInit() {

	}

	ngAfterViewInit(): void {
		if (this.project) {
			this.loadGantt();
		}
	}

	ngOnDestroy(): void {
		if (this.chart)
			this.chart.dispose();
	}

	generateChart() {
		if (this.chart)
			this.chart.dispose();

		this.chart = am4core.create('chartdiv', am4charts.XYChart);
		this.chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

		this.chart.paddingRight = 30;
		this.chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd HH:mm';

		const colorSet = new am4core.ColorSet();
		colorSet.saturation = 0.4;
		let color = colorSet.next();
		this.colors.push(color); // non usando rgb restituito da api mi salvo i colori usati per rimappare la legenda in base all'indice
		this.chart.data = this.gantt.lines.map((line, index) => {
			if (index > 0 && this.gantt.lines[index].rgb !== this.gantt.lines[index - 1].rgb) {
				color = colorSet.next();
				color = colorSet.next(); // doppio next per aumentare contrasto colori adiacenti
				this.colors.push(color);
			}
			const chartline = {
				name: line.name,
				fullname: line.taskname,
				fromDate: new Date(line.start),
				toDate: new Date(line.stop),
				color: color,
				taskid: line.taskid,
				prjmonthstart: line.prjmonthstart,
				prjmonthend: line.prjmonthend

			};
			return chartline;
		});



		const categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = 'name';
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.inversed = true;

		const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.dateFormatter.dateFormat = 'dd/MM/yyyy';
		dateAxis.renderer.minGridDistance = 70;
		dateAxis.baseInterval = { count: 30, timeUnit: 'minute' };
		// dateAxis.max = new Date(2018, 0, 2, 24, 0, 0, 0).getTime();
		dateAxis.strictMinMax = true;
		dateAxis.renderer.tooltipLocation = 0;

		const series1 = this.chart.series.push(new am4charts.ColumnSeries());
		series1.columns.template.width = am4core.percent(80);
		series1.columns.template.tooltipText = '{fullname} - Da mese {prjmonthstart} a mese {prjmonthend}';

		series1.dataFields.openDateX = 'fromDate';
		series1.dataFields.dateX = 'toDate';
		series1.dataFields.categoryY = 'name';
		series1.columns.template.propertyFields.fill = 'color'; // get color from data
		series1.columns.template.propertyFields.stroke = 'color';
		series1.columns.template.strokeOpacity = 1;

		series1.columns.template.events.on('hit', function (ev) {
			console.log('clicked on ', ev.target.dataItem.dataContext);
		}, this);

		this.chart.scrollbarX = new am4core.Scrollbar();
	}

	loadGantt() {
		this.loading = true;
		this.projectService.gantt(this.project).subscribe(result => {
			this.gantt = result;
			this.generateChart();
			this.loading = false;
		}, error => {
			this.messageService.sendError(error.error.msg);
		});
	}



}
